import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Playlist from './Playlist/Playlist';
import classes from './style/Theme.module.css';
import { ApiCenter } from '../../api/ApiCenter';
import { ILesson, ThemeProps } from '../../../types/ThemeType';
import PlayerDescription from './PlayerDescription/PlayerDescription';
import {
  EditOutlined,
  EyeOutlined,
  CloseOutlined,
  ArrowLeftOutlined,
  EyeInvisibleOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { RoleComponentRender, UI_Footer } from '../../../Core/Core';
import { Roles } from '../../../types/Types';
interface ResponseProps {
  data: ThemeProps;
  succes: boolean;
}
const Theme = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState<ThemeProps | null>(null);
  const { HRNYA, SUPER_ADMIN, ADMIN, HEAD_OF_SELLERS, STANDART_USER } = Roles;

  const ApiStart = new ApiCenter();
  const getData = (id: string) => {
    ApiStart.GET_API(`hr/theme/${id}`, 'GET').then((response: ResponseProps) => {
      const updatedData: ThemeProps = {
        lessons: response.data.lessons.map((item: ILesson, index: number) => ({
          ...item,
          isPlaying: index === 0 ? true : false,
        })),
        theme: response.data.theme,
        success: true,
        test: response.data.test,
      };
      setData(updatedData);
    });
  };
  useEffect(() => {
    id && getData(id);
  }, [id]);
  const draftClick = (id: number) => {
    ApiStart.GET_API(`hr/theme/${id}`, 'PATCH', {
      is_draft: true,
    }).then(() => {
      data &&
        setData({
          ...data,
          theme: {
            ...data.theme,
            is_draft: true,
          },
        });
    });
  };
  const visibleClick = (id: number, value = false) => {
    ApiStart.GET_API(`hr/theme/${id}`, 'PATCH', {
      is_visible: value === false ? false : true,
    }).then(() => {
      if (data) {
        setData({
          ...data,
          theme: {
            ...data.theme,
            is_visible: value === false ? false : true,
          },
        });
      }
    });
  };
  const handleClick = (id = -1, order = -1, method = 'increment' || 'decrement') => {
    if (data) {
      if (id > -1 && order === -1) {
        setData({
          ...data,
          lessons: data.lessons.map((item) => ({
            ...item,
            isPlaying: item.id === id ? true : false,
          })),
        });
      }
      if (order > -1 && method === 'increment') {
        setData({
          ...data,
          lessons: data.lessons.map((item) => ({
            ...item,
            isPlaying: item.lesson_order === order + 1 ? true : false,
          })),
        });
      }
      if (order > -1 && method === 'decrement') {
        setData({
          ...data,
          lessons: data.lessons.map((item) => ({
            ...item,
            isPlaying: item.lesson_order === order - 1 ? true : false,
          })),
        });
      }
    }
  };
  useEffect(() => {
    return;
  }, [data]);

  if (!data) {
    return null;
  }
  const { lessons } = data;

  return (
    <div className={classes.wrapper}>
      <div className={classes.headerButtonWrapper}>
        <Button>
          <Link to={`../`}>
            <ArrowLeftOutlined style={{ paddingRight: '1em' }} />
            Назад к темам
          </Link>
        </Button>
        <Button style={{ border: 'none', borderColor: 'none' }}>
          <Link style={{ color: 'black' }} to={`../`}>
            <CloseOutlined />
          </Link>
        </Button>
      </div>
      <h2 className={classes.header}>{`Курс "${data.theme.title}"`}</h2>
      <div className={classes.wrapperTheme}>
        <div className={classes.playerWrapper}>
          {lessons.length ? (
            <PlayerDescription
              data={data.lessons.filter((item) => item.isPlaying === true)[0]}
              quantityLessons={data?.lessons.length || 1}
              handleClick={handleClick}
            />
          ) : null}
        </div>
        <div className={classes.playlistWrapper}>
          {lessons && <Playlist lessons={lessons} handleClick={handleClick} />}
          <div className={classes.lineDivider}></div>
          <RoleComponentRender roles={[HRNYA, SUPER_ADMIN, ADMIN]}>
            {data.test && (
              <div className={classes.testCountWrapper}>
                <h4>{`Тест "${data.theme.title}"`}</h4>
                <p className={classes.testCount}>{`Количество вопросов: ${
                  data.test ? data.test.questions_count : '-/-'
                }`}</p>
              </div>
            )}
          </RoleComponentRender>
          <RoleComponentRender roles={[HEAD_OF_SELLERS, STANDART_USER]}>
            {data.test && (
              <div className={classes.testCountWrapper}>
                <h4>Тест по пройденному материалу</h4>
                <div className={classes.ContetnGrup}>
                  {data.test.result?.is_passed === true ? (
                    <>
                      <div>
                        Результаты теста: {data.test.result?.points}/
                        {data.test.result?.questions_count}
                      </div>
                      Тест пройден
                    </>
                  ) : (
                    <>
                      <div>Результаты теста: -/-</div>
                      <Button onClick={() => navigate(`../test-questions/${data.test.id}`)}>
                        Пройти тест
                      </Button>
                    </>
                  )}
                </div>
              </div>
            )}
          </RoleComponentRender>
        </div>
      </div>
      <div className={classes.hrButton}>
        <RoleComponentRender roles={[HRNYA, SUPER_ADMIN, ADMIN]}>
          <UI_Footer style={{ boxShadow: 'none' }}>
            <div>
              <Button onClick={() => draftClick(data.theme.id)}>Переместить в черновик</Button>
            </div>
            <div>
              {data.theme.is_visible ? (
                <Button style={{ marginRight: '1em' }} onClick={() => visibleClick(data.theme.id)}>
                  <EyeOutlined />
                  Скрыть тему
                </Button>
              ) : (
                <Button
                  style={{ marginRight: '1em' }}
                  onClick={() => visibleClick(data.theme.id, true)}
                >
                  <EyeInvisibleOutlined />
                  Показать тему
                </Button>
              )}
              <Button type="primary">
                <Link style={{ color: 'white' }} to={`../edit-theme/${data.theme.id}`}>
                  <EditOutlined style={{ paddingRight: '1em' }} />
                  Редактировать тему
                </Link>
              </Button>
            </div>
          </UI_Footer>
        </RoleComponentRender>
      </div>
    </div>
  );
};
export default Theme;
